import React from "react";
import { onError } from "src/common/onError";
import { makeLabelsDefs } from "./labelMakers";
import { StrategyInterpretView } from "./StrategyInterpretView";
import { MakeLabelParams } from "./types/MakeLabelParams";
import { makeLabelsDefs4EntityCard } from "./labelMakers/makeLabelsDefs";

export enum MakeLabelMode {
  default,
  entityCard,
}

export const makeAttrLabel = (params: MakeLabelParams): React.ReactNode => {
  try {
    const interpreter = new StrategyInterpretView(
      params.mode === MakeLabelMode.entityCard
        ? makeLabelsDefs4EntityCard()
        : makeLabelsDefs(),
    );
    interpreter.bind(params);
    return interpreter.execute();
  } catch (error) {
    onError(error);
    return null;
  }
};
